import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import socketIOClient from 'socket.io-client'
import {
  setAdminId,
  setShowFeedback,
  setUserDetails,
} from 'src/redux/reducer/commomReducer.js/commonReducer'
import { removeOfflineMessage } from 'src/redux/reducer/messageReducer.js/messageReducer'
import Chat from './UserChat'

const User = () => {
  const dispatch = useDispatch()
  const [socket, setSocket] = useState(null)
  const [listMessage, setListMessage] = useState([])
  // const [adminId, setAdminId] = useState('anonomyous')
  // const [online, setOnline] = useState(false)
  const [chatEnded, setChatEnded] = useState(false)
  const { showFeedback, adminId } = useSelector((state) => state.common)
  const [endChat, setEndChat] = useState(false)
  const [userId, setUserId] = useState(null)
  const [loggedIn, setLoggedIn] = useState(false)
  const [userPhno, setUserPhno] = useState('')
  const intervalRef = useRef(null)
  const lastMessageTime = useRef(null)

  const ref = useRef(null)

  const sock = useRef(null)

  const storeRef = useRef(null)

  const automatedMessage = useRef(null)

  const { offlineMessageList } = useSelector((state) => state.message)

  const createSocketConnection = (token) => {
    const soc = socketIOClient(process.env.REACT_APP_BACKEND_URL, {
      query: `token=${token}`,
      transports: ['websocket'],
      forceNew: true,
    })
    setSocket(soc)
    sock.current = soc
  }

  const setLastMessageTime = (time) => {
    lastMessageTime.current = time
  }

  const getUserDetails = async (headers) => {
    try {
      const resp = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user/getOneEndUser`, {
        headers: headers,
      })

      if (resp.data.data.assigned) {
        dispatch(setAdminId(resp.data.data.assignedBy))
      }
      dispatch(setUserDetails(resp.data.data))
      setEndChat(resp.data.data.endChat)
      setUserId(resp.data.data._id)
      setUserPhno(resp.data.data.phoneNumber)
    } catch (error) {
      console.log(error)
    }
  }

  const createMessage = async (request) => {
    try {
      if (localStorage.getItem('userId')) {
        const userData = JSON.parse(localStorage.getItem('userId'))
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        }

        const resp = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/message/create-message`,
          {
            to: request.to,
            from: request.from,
            message: request.message,
          },
          {
            headers: headers,
          },
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const sendContinousMessage = (user, admin) => {
    const obj = {
      1:
        'We appreciate your patience. All of our Counselors seem busy at the moment. ' +
        '\n Soon a counselor will be connected to you. Meanwhile, you may access iCALL’s other services here:' +
        '\n\n \xa0\xa0  ■  \xa0\xa0\xa0 iCALL website: https://icallhelpline.org/ '
        // + '\n	\xa0\xa0  ■  \xa0\xa0\xa0 iCALL’s WhatsApp Chatbot: +91 2250323342'
      ,
      2:
        'Unfortunately, all of the counselors seem to be busy at the moment. We would strongly encourage you to seek assistance in moments of distress. In case, you wish to access support from iCALL’s other modalities you can contact iCALL through' +
        '\n\n \xa0  ■  Helpline: 9152987821' +
        '\n \xa0  ■  Email ID: icall@tiss.ac.in' +
        '\n \xa0  ■  Self-help resources' +
        '\n 	\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0  1.	 Website: https://icallhelpline.org/' +
        // '\n 	\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0  2.	 Chat-bot: +91 2250323342' +
        '\n\n Or if you wish to have in-person therapy, you may refer to the crowdsourced list of mental health professionals https://docs.google.com/spreadsheets/d/1pzckT6ns2H1IlmwYwJa8EnBh_1u3gRA9cEOoA4zfilc/edit#gid=370032083 ',
    }
    let count = 1
    intervalRef.current = setInterval(() => {
      let request
      if (automatedMessage.current || count === 3 || ref.current === 'clear') {
        clearInterval(intervalRef.current)
        return
      }

      if (lastMessageTime.current === null) {
        request = {
          message: obj[count],
          from: admin ? admin : adminId,
          to: user ? user : userId,
          createdAt: new Date(),
          state: true,
        }
        setListMessage((prev) => {
          return [...prev, request]
        })
        sock.current.emit('send-user', request)
        count++
      } else {
        if (new Date().getTime() / 1000 - lastMessageTime.current > 10) {
          request = {
            message: obj[count],
            from: admin ? admin : adminId,
            to: user ? user : userId,
            createdAt: new Date(),
            state: true,
          }
          setListMessage((prev) => {
            return [...prev, request]
          })
          sock.current.emit('send-user', request)
          count++
        }
      }
    }, [40000])
  }

  useEffect(() => {
    if (localStorage.getItem('userId')) {
      const userData = JSON.parse(localStorage.getItem('userId'))
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userData.token}`,
      }
      getUserDetails(headers)
      createSocketConnection(userData.token)
    }

    return () => {
      ref.current = 'clear'
      clearInterval(intervalRef.current)
    }
  }, [])

  useEffect(() => {
    storeRef.current = {
      offlineMessageList,
      adminId,
    }
  }, [offlineMessageList.length, adminId])

  useEffect(() => {
    automatedMessage.current = endChat
  }, [endChat])

  useEffect(() => {
    if (socket && userId) {
      socket.off('message').on('message', (data) => {
        if (Array.isArray(data)) {
          setListMessage(data)
        } else {
          setListMessage((prevState) => {
            const index = prevState.findIndex((e) => e.createdAt === data.createdAt)
            if (index != -1) {
              prevState.splice(index, 1)
            }
            return [...prevState, data]
          })
        }
        // setLastMessageTime(new Date().getTime() / 1000)
        if (data.from === userId || data.from === 'anonomyous') {
          setLastMessageTime(new Date().getTime() / 1000)
        } else {
          clearInterval(intervalRef.current)
        }
      })
      socket.io.off('reconnect').on('reconnect', (attempt) => {
        const interval = setInterval(() => {
          if (socket.connected) {
            // socket.emit('get-all-user-messages', {
            //   messages: storeRef.current ? storeRef.current.offlineMessageList : null,
            //   adminId: storeRef.current ? storeRef.current.adminId : null,
            // })
            // storeRef.current = null
            clearInterval(interval)
            dispatch(removeOfflineMessage())
          }
        }, [100])
      })

      socket.off('user-assigned-to-admin').on('user-assigned-to-admin', (data) => {
        dispatch(setAdminId(data))
        setEndChat(false)
      })
      socket.off('user-chat-ended').on('user-chat-ended', (data) => {
        if (!data?.feedback) {
          dispatch(setShowFeedback(true))
        }
        automatedMessage.current = true
        setEndChat(true)
        setChatEnded(true)
      })
    }
  }, [socket, userId])

  return (
    <>
      <div style={{ bottom: 60, right: 10, width: '95%', height: '100%' }}>
        <Chat
          socket={socket}
          setListMessage={setListMessage}
          adminId={adminId}
          setAdminId={setAdminId}
          // online={online}
          // setOnline={setOnline}
          listMessage={listMessage}
          createSocketConnection={(token) => createSocketConnection(token)}
          createMessage={(request) => createMessage(request)}
          chatEnded={chatEnded}
          showFeedback={showFeedback}
          // setshowFeedback={setShowFeedback}
          setChatEnded={setChatEnded}
          loggedIn={loggedIn}
          setLoggedIn={setLoggedIn}
          userId={userId}
          setUserId={setUserId}
          userPhno={userPhno}
          setUserPhno={setUserPhno}
          endChat={endChat}
          setEndChat={setEndChat}
          intervalRef={intervalRef}
          setLastMessageTime={setLastMessageTime}
          sendContinousMessage={sendContinousMessage}
        />
      </div>
    </>
  )
}

export default User
